import { render, staticRenderFns } from "./q-pop-yibao.vue?vue&type=template&id=6ffb88a2&scoped=true&"
import script from "./q-pop-yibao.vue?vue&type=script&lang=js&"
export * from "./q-pop-yibao.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-yibao.vue?vue&type=style&index=0&id=6ffb88a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb88a2",
  null
  
)

export default component.exports